import { Client, CityOption, PaginationParams, User } from "../../users.type";
import { RoleType, Roles } from "@/store/auth/auth.type";

import { ColumnDef, OnChangeFn, SortingState } from "@tanstack/react-table";
import { CreateNewUserModal } from "@/modules/users/components/create-new-user-modal";
import { DataTable } from "./data-table";
import { clientColumns } from "../clients/clients-column";
import { routes } from "@/routes/constants";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { userColumns } from "../users/users-column";

type DataTableUserProps = {
  userType: RoleType;
  data: User[] | Client[];
  loading?: boolean;
  currentPage: PaginationParams;
  setCurrentPage: (page: number) => void;
  totalPage: number;
  onRefetch?: () => void;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  pageSize?: number;
  onPageSizeChange?: (size: number) => void;
  hideSearch?: boolean;
  cities?: CityOption[];
  cityId?: string;
  onCityChange?: (id: string) => void;
  sorting: SortingState;
  onSortingChange: OnChangeFn<SortingState>;
};

export const DataTableUser = ({
  userType,
  data,
  loading,
  currentPage,
  setCurrentPage,
  totalPage,
  onRefetch,
  searchValue,
  onSearchChange,
  pageSize,
  onPageSizeChange,
  hideSearch,
  cities,
  cityId,
  onCityChange,
  sorting,
  onSortingChange,
}: DataTableUserProps) => {
  const navigate = useNavigate();
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  const handleClientDetails = (clientId: string) => {
    navigate(routes.clientDetail.path.replace(":id", clientId), {
      state: { role: userType, page: currentPage.pageIndex },
    });
  };

  const handleEdit = (user: User) => {
    setSelectedUser(user);
  };

  const columns =
    userType === Roles.CLIENT ? clientColumns(handleClientDetails) : userColumns({ onEdit: handleEdit, onRefetch });

  const typedData = userType === Roles.CLIENT ? (data as Client[]) : (data as User[]);

  return (
    <>
      <DataTable
        columns={columns as ColumnDef<User>[]}
        data={typedData}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
        hideSearch={hideSearch}
        cities={cities}
        cityId={cityId}
        onCityChange={onCityChange}
        sorting={sorting}
        onSortingChange={onSortingChange}
      />
      {selectedUser && (
        <CreateNewUserModal user={selectedUser} onClose={() => setSelectedUser(null)} onSuccess={onRefetch} />
      )}
    </>
  );
};
